import { ChangeEvent, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { JobOfferKindListType } from 'types/kodawari';

/**
 * 応募方法に関するカスタムフック
 * @param initialJobOfferKindList
 * @returns 応募方法の値と更新する関数を含むオブジェクト
 */
export const useJobOfferKind = (
  initialJobOfferKindList: JobOfferKindListType[]
) => {
  const [jobOfferKindList, setJobOfferKindList] = useState<
    JobOfferKindListType[]
  >(initialJobOfferKindList);

  const selectedJobOfferKindList = jobOfferKindList
    .filter(({ isChecked }) => isChecked)
    .map(({ value }) => value)
    .at(0);

  // チェック状態更新処理
  const updateIsCheckedJobOfferKindList = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const checkedList = jobOfferKindList.map((item) => {
      if (item.value !== event.target.value)
        return {
          ...item,
          isChecked: false,
        };

      return {
        ...item,
        isChecked: event.target.checked,
      };
    });

    setJobOfferKindList(checkedList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value)
      .at(0);
  };

  // 求人件数更新処理
  const updateJobOfferKindListJobCount = (
    jobOfferKindListJobCountList: JobCountDetailResponse[] | undefined
  ) => {
    setJobOfferKindList((pre) =>
      pre.map((item) => ({
        ...item,
        jobCount: findJobCount(jobOfferKindListJobCountList, item.value),
      }))
    );
  };

  // チェック状態クリア処理
  const clearIsCheckedJobOfferKindList = () => {
    const checkedList = jobOfferKindList.map((item) => {
      return {
        ...item,
        isChecked: false,
      };
    });
    setJobOfferKindList(checkedList);
  };

  return {
    jobOfferKindList,
    selectedJobOfferKindList,
    updateIsCheckedJobOfferKindList,
    updateJobOfferKindListJobCount,
    clearIsCheckedJobOfferKindList,
  };
};
